import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { QuestionType } from '../../enums/question-type.enum';
import { Question } from '../../interfaces/meta/question';

@Component({
    selector: 'app-question-component',
    templateUrl: 'question.component.html',
    styleUrls: ['question.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionComponent {
    @Input() public question: Question;
    @Input() public group: UntypedFormGroup;

    public readonly questionType = QuestionType;
}
